import Vue from "vue";
import Router from "vue-router";
import pageConfig from "@/config/page";
import demo from "./demo";
const page = pageConfig.pages;

Vue.use(Router);

const router = new Router({
  routes: [
    {
      name: "login",
      path: "/login",
      component: () => import("@/pages/login"),
      props: { action: 0 },
      meta: {
        layout: false,
        auth: false,
      },
    },
    {
      name: "init",
      path: "/init",
      component: () => import("@/pages/Init"),
      props: true,
      meta: {
        layout: false,
        auth: false,
      },
    },
    {
      name: "forgetPwd",
      path: "/forgetPwd",
      component: () => import("@/pages/cellPhoneValidate"),
      props: { isForgetPwd: true },
      meta: {
        layout: false,
        auth: false,
      },
    },
    {
      name: "restoreAccount",
      path: "/restoreAccount",
      component: () => import("@/pages/cellPhoneValidate"),
      props: { isForgetPwd: false },
      meta: {
        layout: false,
        auth: false,
      },
    },
    {
      name: "changePwd",
      path: "/changePwd",
      component: () => import("@/pages/changePwd"),
      meta: {
        layout: false,
        auth: false,
      },
    },
    {
      name: "limit",
      path: "/limit",
      component: () => import("@/pages/limit"),
      meta: {
        layout: false,
        auth: false,
      },
    },
    {
      path: "/test",
      component: () => import("@/layout/TgApp"),
      children: [
        {
          path: "",
          component: () => page.test,
          meta: {
            title: "portal",
          },
        },
      ],
    },
    ...demo,
  ],
});

// document.onmouseover = function() {
//   //User's mouse is inside the page.
//   window.innerDocClick = true;
// };

// document.onmouseleave = function() {
//   //User's mouse has left the page.
//   window.innerDocClick = false;
// };

// window.onpopstate = (...args) => {
//   console.log(args);
// };
export default router;
